import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import Pricing from "./sections/Pricing";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <Pricing />
      <CommonQuestions />
      <Footer />
    </div>;
}